module.exports = __webpack_public_path__ + "img/lang-select-bg.e605f4b2.png";